import { apiClient } from "../../../lib";

export const commercialsApi = {

    fetchBudgets: async ({ projectId }: { projectId: string | undefined }): Promise<any> => {
        const response = await apiClient.get(`/projects/${projectId}/budgets`);
        return response.data;
    },

    fetchBudgetStates: async (projectId: string | undefined): Promise<any> => {
        const response = await apiClient.get(`/projects/${projectId}/budgets/stats`);
        return response.data;
    },

    fetchBudgetCategories: async (projectId: string | undefined): Promise<any> => {
        const response = await apiClient.get(`/projects/${projectId}/budgets/categories`);
        return response.data;
    },

    fetchCommitments: async ({ projectId, searchKey }: { projectId: string | undefined, searchKey: string }): Promise<any> => {
        const response = await apiClient.get(`/projects/${projectId}/commitments?search_term=${searchKey}`);
        return response.data;
    },

    fetchAdjustments: async ({ projectId, page, limit }: { projectId: string | undefined, page: number, limit: number }): Promise<any> => {
        const response = await apiClient.get(`/projects/${projectId}/adjustments?page=${page}&limit=${limit}`);
        return response.data;
    },

    fetchPayments: async ({ projectId, page, limit, searchKey }: { projectId: string | undefined, page: number, limit: number, searchKey: string }): Promise<any> => {
        const response = await apiClient.get(`/projects/${projectId}/payments?page=${page}&limit=${limit}&search_term=${searchKey}`);
        return response.data;
    },

    fetchVariations: async ({ projectId, page, limit, searchKey }: { projectId: string | undefined, page: number, limit: number, searchKey: string }): Promise<any> => {
        const response = await apiClient.get(`/projects/${projectId}/variations?page=${page}&limit=${limit}&search_term=${searchKey}`);
        return response.data;
    },

    fetchForecast: async ({ projectId }: { projectId: string | undefined }): Promise<any> => {
        const response = await apiClient.get(`/projects/${projectId}/graphs`);
        return response.data;
    },

    fetchForecastTable: async ({ projectId, page, limit }: { projectId: string | undefined, page: number, limit: number }): Promise<any> => {
        const response = await apiClient.get(`/projects/${projectId}/forecasts?page=${page}&limit=${limit}`);
        return response.data;
    },

};